import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/home-main.svg";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Particle from "../ParticleTS";
import Tilt from "react-parallax-tilt";
import FindMeOn from "./FindMeOn";
import Gallery from "../Gallery";


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              A little bit about <span className="purple">me</span>.
            </h1>
            <p className="home-about-body">
            I'm a Computer Science undergraduate at UoW, and I enjoy working with DevOps, Cloud Computing and Coding. 💻 I like to think of debugging as a small strategy game, the bugs make their move and I make mine.
              <br />
              <br />I have over two years of experience exploring the DevOps space, learning different tools and building things that make work easier and faster. I really enjoy figuring out how systems fit together and how to automate everyday tasks.
              <br />
              <br />
              I also like helping others whenever I can. Sharing what I know, explaining a concept or guiding someone through a problem is something I genuinely enjoy. And as a gamer, I've noticed that some of my best ideas show up right after a tough boss battle, maybe problem-solving works the same everywhere. 🎮
              &nbsp;



            </p>
          </Col>

        </Row>

      </Container>

      <Container >
        <Container fluid className="about-section">
          <Row>
            <Col md={12} className="home-about-social">
              <FindMeOn />
            </Col>
          </Row>
          <Gallery />
        </Container>

      </Container>
      <Particle />
    </Container>

  );
}
export default Home2;
